// extracted by mini-css-extract-plugin
module.exports = {"container":"tile-group-tab_container__X7V7G","tabContent":"tile-group-tab_tabContent__4BPN_","header":"tile-group-tab_header__3fX1j","fade-in":"tile-group-tab_fade-in__ikxCH"};